import React from 'react';

// Components
import { Provider } from 'react-redux';
import { Router } from 'react-router';
import getRoutes from 'routes/Routes.jsx';
import ErrorBoundary from 'common/ErrorBoundary';
import { renderUsingContextVersion } from 'util/renderUsingContextVersion';

const startApp = async (store, history) => {
  const routes = getRoutes(store);

  const app = (
    <ErrorBoundary>
      <Provider store={store}>
        <Router history={history} routes={routes} />
      </Provider>
    </ErrorBoundary>
  );
  renderUsingContextVersion(app, document.getElementById('app'));
};
export default startApp;
